import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import Button from "../../elements/Button";
import classes from "./Controls.module.scss";

type ControlsProps = {
  handleGetStarted: () => void;
  disabled?: boolean;
};

const Controls: FC<ControlsProps> = ({ handleGetStarted, disabled = false }) => {
  const history = useHistory();

  const handleBack = () => history.push("/dashboard");

  return (
    <div className={classes.container}>
      <Button variant="outlined" onClick={handleBack}>
        Back
      </Button>
      <Button variant="contained" onClick={handleGetStarted} disabled={disabled}>
        Get Started
      </Button>
    </div>
  );
};

export default Controls;
